export default class ErrorBag {
  errors: any;
  constructor(errors = null) {
    this.errors = errors;
  }

  setAll(errors: any) {
    this.errors = errors;
  }

  has(field: string) {
    return this.errors && Object.prototype.hasOwnProperty.call(this.errors, field);
  }

  first(field: string) {
    if (this.has(field) && this.errors[field].length > 0) {
      return this.errors[field][0];
    }
  }
  getMessage(field: string) {
    if (this.has(field) && this.errors[field].length > 0) {
      return this.errors[field];
    }
  }
}
